export default "__VITE_ASSET__760c31e4__"